import axios from "../utils/axios";

export async function getKeyMomentFilterOptions(searchOptions){
    const response = await axios.post(`/key_moment/v2/filterOptions`, {searchOptions});
    return response.data
}

export async function revertKeyMoment(id) {
    const payload = {
        id: id
    }

    const response = await axios.post("/key_moment/v2/revert", payload);
    return response.data;
}

export async function getStaticOptions() {
    const response = await axios.get('key_moment/v2/getStaticOptions');
    return response.data;
}

export async function getCollectionById(collectionId, needMerge = false){
    const response = await axios.get(`key_moment/v2/collections/${collectionId}`, {params: {need_merge: needMerge}});
    return response.data
}

export async function updateKeyMomentSimple(id, field, value) {
    const payload = {
        id: id,
        [field]: value
    }

    const response = await axios.put("/key_moment/v2/simpleUpdate", payload);
    return response.data;
}

export async function getKeyMomentCollectionFilterOptions(){
    const response = await axios.post(`/key_moment/v2/collection/filterOptions`);
    return response.data
}

export async function updateKeyMomentCollection(collectionId, body){
    const response = await axios.put(`key_moment/v2/collection/${collectionId}`, body)
    return response.data
}

export async function deleteKeyMomentCollection(collectionId){
    const response = await axios.delete(`key_moment/v2/collection/${collectionId}`)
    return response.data
}

export async function deleteKeyMoment(keyMomentId){
    const response = await axios.delete(`key_moment/${keyMomentId}`)
    return response.data
}

export async function deleteKeyMomentCutMaster(keyMomentId) {
    const response = await axios.delete(`key_moment/v2/key_moment/${keyMomentId}/cuts`)
    return response.data
}

export async function createKeyMomentCollection(body){
    const response = await axios.post(`key_moment/v2/collection`, body)
    return response.data
}

export async function getAllKeyMoments(){
    const response = await axios.post(`key_moment/v2`, {page: 0, page_size: 10})
    return response.data
}

export async function getKeyMomentStreams(){
    const response = await axios.get(`match/tempStreams`)
    return response.data
}

export async function getKeyMomentId(id){
    const response = await axios.get(`key_moment/v2/keymoment/${id}`)
    return response.data
}

export async function bulkUpdateKeyMoments(keyMoments){
    const response = await axios.put(`key_moment/v2/bulkUpdate`, keyMoments)
    return response.data
}

export async function updateKeyMoment(keyMoment){
    const response = await axios.put(`key_moment/v2/singleUpdate`, keyMoment)
    return response.data
}

export async function createManualKeyMomentRequest(keyMoment){
    const response = await axios.post('key_moment/v2/manual_creation', keyMoment)
    return response.data
}

export async function getKeyMomentByIds(keyMomentIds){
    const response = await axios.post(`key_moment/v2/keymoment/keyMomentsByIds`, keyMomentIds)
    return response.data
}

export async function suggest(idEvent, min_duration, max_duration, highlight_type = "Regular", player, matchDay, competition, keyMomentsTypes, keyMomentsIds, keyMomentFilters, needMerge = false, lockedKeyMoments = []){

    const body = {
        events: idEvent ? [idEvent] : [],
        matchday: matchDay,
        competition: competition,
        min_duration: min_duration,
        max_duration: max_duration,
        highlight_type: highlight_type,
        key_moments: keyMomentsTypes,
        key_moment_ids: keyMomentsIds,
        km_filter: keyMomentFilters,
        need_merge: needMerge,
        locked_key_moment_ids: lockedKeyMoments
    }

    const response = await axios.post(`key_moment/v2/suggest`, body)
    return response.data;
}

export async function getKeyMoments(filters, pageSize = null, page = null, sortBy = 'created_at', sortOrder = 'desc', additionalFilters, needMerge = false) {
    const response = await axios.post(`key_moment/v2`, {
        filters,
        page,
        page_size: pageSize,
        sort_by: sortBy,
        sort_order: sortOrder,
        km_filter: additionalFilters,
        need_merge: needMerge
    })
    return response.data
}

export async function updateKeyMomentMasterCuts(cuts) {
    const cutBody = cuts.map(({coordinates, ...rest}) => rest)
    const response =  await axios.put(`key_moment/v2/master_cuts`, {cuts: cutBody});
    return response.data
}